import { ToastOptions } from '@ionic/react';

export interface ReminderForegroundArgs {
    notification: { title?: string; body?: string };
    showToast: (opts: ToastOptions) => Promise<unknown>;
    navigate: (() => void | Promise<void>) | null;
}

export const handleReminderForeground = async (
    args: ReminderForegroundArgs,
): Promise<boolean> => {
    const { notification, showToast, navigate } = args;

    if (!notification.title && !notification.body) {
        return false;
    }

    const opts: ToastOptions = {
        header: notification.title,
        message: notification.body,
        duration: 5000,
        position: 'top',
    };

    if (navigate) {
        opts.buttons = [{
            text: 'View',
            handler: () => {
                Promise.resolve()
                    .then(() => navigate())
                    .catch((err) => console.error('Reminder navigate failed:', err));
            },
        }];
    }

    await showToast(opts);
    return true;
};
